<template>
  <div class="content-wraper">
    <template>
      <v-row>
        <v-col :cols="displayTime ? '6' : '10'" class="field-date-picker" max-width="150px">
          <v-menu ref="dTPkr" v-model="menu" transition="fade-transition" min-width="280" :close-on-content-click="false"
            :close-on-click="false" offset-y allow-overflow offset-overflow>
            <template v-slot:activator="{ on }">
              <v-text-field dense 
              :label="GetLabel"
                v-model="formattedSavedDate" 
                prepend-icon="mdi-calendar-month" 
                v-bind="$attrs" 
                v-on="on"
                @focus="customFocus(true, 0)" 
                :placeholder="$attrs.placeholder ? $attrs.placeholder : format"
                @blur="onDateChange($event)" 
                @click="openMenu()" 
                autocomplete="off" 
                @mouseover="closeLocked = true"
                @mouseout="closeLocked = false" 
                v-click-outside="closeMenu" 
                @keypress.enter.native="userSave"
                @keypress.esc.native="userCancel" 
                @keyup.native="menu = false" 
                @keyup.backspace.native="menu = false"
                :class="[getIrisCssClass, getDateTimeClass]" 
                :readonly="disableDataInput" 
                :filled="getIrisRdonlyMode"
                :on="on" 
                :ename="$attrs.ename" 
                :id="$attrs.id" 
                ref="dateIn" 
                class="dateTimeInput no-gutters pa-0 mt-1"
                type="text" 
                :rules="rules">
                </v-text-field>
            </template>
            <v-card max-width="300" 
            ref="dateTimePicard" 
            @mouseover="closeLocked = true" 
            @mouseout="closeLocked = false"
            @keypress.enter.native="userSave" 
            @keypress.esc.native="userCancel">
              
              <edn-date 
              v-if="!disableDataInput"
              :locale="getDateLocale()" 
              v-model="savedDate" 
              :format="format" 
              :min="min"
              @changeDate="inputDate($event)" 
              :readonly="disableDataInput">
              </edn-date>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="4" class="dropdown-time" v-if="displayTime">
          <v-combobox ref="timePicker" prepend-icon="mdi-clock-outline" id="timeField" v-model="formattedSavedTime" v-click-outside="closeMenuCombo"
            :items="timeItems" dense @input="inputCheck($event)" append-icon="" menu-props="auto"  :readonly="disableDataInput"></v-combobox>
        </v-col>
      </v-row>
    </template>
  </div>
</template>
<script>
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'

import {
  format as fnsFormat,
  parseISO as fnsParseISO,
  isValid as fnsIsValid,
  parse as fnsParse,
  formatRelative,
  subDays,
} from 'date-fns'
import { fr, enGB, es, de, nl, it } from 'date-fns/locale'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednMimicMix],
  props: {
    value: {
      type: String,
      default: () => null,
    },
    min: {
      type: String,
      default: () => null,
    },
    format: {
      type: String,
      default: () => 'dd/MM/yyyy',//Formats supportées: "EE d MMM yyyy","EE dd/MM/yyyy","EEEE d MMMM yyyy","dd/MM/yyyy", "MM/dd/yyyy", "yyyy/MM/dd", "yyyy-MM-dd"
    },
    timeRequired: {
      type: Boolean,
      default: () => false,
    },
    required: {
      type: [String, Boolean],
      default: () => false
    },
    displayTime: {
      type: Boolean,
      default: true
    },
    invalidDateMsg: {
      type: String,
      default: () => '',
    },
    addDateFormatRule: {
      type: Boolean,
      default: () => true
    },
    readonly:{
      type: Boolean,
      default: false
    }
  },
  created() {
    if(this.value)
    {
      this.savedDate =  fnsFormat(new Date(this.value),this.format);

      this.savedTime = fnsFormat(new Date(this.value),"HH:mm"); 
    
      this.timeItems = this.generateItemList();
     }
  },
  watch: {
    savedDate(val) {
      this.timeItems = this.generateItemList();

      if (this.min != null && this.min != '') {
        let beginDate = this.min.split('T')[0];

        if (beginDate == val) {
          this.getTimeFromMin();
        }
      }
    },
    min(val) {
      if (!this.min)
        return;
      let minDate = this.min.split('T')[0];
      if (minDate == this.savedDate) {
        this.timeItems = this.generateItemList();
        this.getTimeFromMin();
      }
    },
   value(val){
      if(val)
      {

        this.savedDate = fnsFormat(new Date(val),this.format,{locale: this.getDateFnsLocale()});

        this.savedTime = fnsFormat(new Date(val),"HH:mm");
        
        let formatedDate = this.fnsParse(this.savedDate, this.format, new Date(),{locale: this.getDateFnsLocale()})
        this.formattedSavedDate = fnsFormat(formatedDate, this.format,{locale: this.getDateFnsLocale()});
                
      }else{
        this.formattedSavedTime = "";
        this.formattedSavedDate = "";
      }
        
    }
    
  },
  data() {
    return {
      menu: false, //Définit si le menu est visible ou non
      closeLocked: false,
      currentTab: null, //Définit l'onglet courant

      savedDate: null, //Stocke la date
      savedTime: null, //Stocke l'heure en ne gardant que l'heure et les minutes

      colors: {
        //Définit les couleurs de vuetify
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      },
      enGB,
      fr,
      es,
      de,
      nl,
      it,
      formatRelative,
      subDays,
      timeItems: [],
      formattedSavedDate: null
    }
  },
  mounted() {
    if(this.addDateFormatRule)
      this.setDateFormatRule();
    this.changeSavedDates();
    if (this.savedDate && this.savedDate != '')
      this.formattedSavedDate = fnsFormat(fnsParseISO(this.savedDate), this.format, { locale: this.getDateFnsLocale() });
  },
  computed: {
    formattedSavedTime: {
      get() {
        return this.savedTime;
      },
      set(value) 
      {
        if(!value)
        {
          this.savedTime = "";         
        }else
        {
             let oldSAvetime = this.savedTime;
            let time = !value.text ? value : value.text
            if(this.isTimeSyntaxIncorrect(time))
            {
              this.savedTime = oldSAvetime         
            }else
            {
                this.savedTime = time
                if (this.savedDate && this.savedTime) 
                {
                  let newDate = new Date(this.savedDate + ' ' + this.savedTime);

                  if (fnsIsValid(newDate)) 
                  {
                  let dateString = this.savedDate + 'T' + this.savedTime;
                  this.$emit('input', dateString)
                  }        
                }
            }
        }  
      },
    },
    
    getDateTimeClass() {
      return this.getIrisRdonlyMode ? 'v-text-field--filled edn-datetime--readonly' : ''
    },
    disableDataInput(){
      return this.readonly;
    },
    GetLabel(){
      if(this.fldRequiredVal && !!this.$attrs.label )
      {
        return this.$attrs.label + ' *' 
      }       
        return this.$attrs.label   
           
    }
  },
  methods: {
    
    /**
     * Renvoie la langue de la date, par défaut en fr
     */
    getDateLocale() {
      if(this.$attrs.locale && this.$attrs.locale != '')
        return this.$attrs.locale;
      return 'fr';
    },
    /***
     * Renvoie la langue à utiliser donDateChangeans date-fns
     */
    getDateFnsLocale() {
      switch (this.getDateLocale()) {
        case 'en':
        case 'enGB':
          return this.enGB;
          break;
        case 'fr':
        case '':
        default:
          return this.fr;
          break;
      }
    },
    /**
     * cette fonction permet d'ajouter la régle de vérification du format de la date
     */
    setDateFormatRule() {
      let that = this;
      let emptyField;
      this.rules.push(function (v) {
        // Règle poussée pour faire un callback en cas d'erreur de format.
        if(!that.fldRequiredVal && v === "")
          return true;
        else
          return (fnsIsValid(fnsParse(v, that.format, new Date(), {locale:that.getDateFnsLocale()})) || that.invalidDateMsg)
      })
    },
    /****
     * Cette fonction permet de reinitialiser la date
     */
    resetDate() {
      this.savedDate = '';
    },
    /****
     * Cette fonction permet de mettre à jour une date
     * 
     */
    setDate(date) {
      this.savedDate = date;
      let newDate = new Date(this.savedDate);
      if (fnsIsValid(newDate)) {
        this.formattedSavedDate = fnsFormat(fnsParseISO(this.savedDate), this.format, { locale: this.getDateFnsLocale() });
      }
    },
    generateItemList() {
      //return Array(24 * 2).fill(0).map((_, i) => { return { text: ('0' + ~~(i / 4) + ':0' + 60 * (i / 2 % 1)).replace(/\d(\d\d)/g, '$1'), disabled: true } })

      var quarterHours = ["00", "30"];
      var times = [];
      for (var i = 0; i < 24; i++) {
        for (var j = 0; j < 2; j++) {
          var time = i + ":" + quarterHours[j];
          if (i < 10) {
            time = "0" + time;
          }
          times.push({
            text: time,
            disabled: false
          });
        }
      }
      return times;
    },
    getTimeFromMin() {
      if (this.min != null && this.min != '') {
        let minTime = this.min.split('T')[1];

        for (let item = 0; item < this.timeItems.length; item++) {
          if (minTime >= this.timeItems[item].text) {
            this.timeItems[item].disabled = true;
          }
          else {
            this.timeItems[item].disabled = false;
          }
        }
      }
    },
    /** Fait la transformation de la valeur pour la transmettre au bon format au composant edn-time et edn-date 
     * Si on vient de la saisie guidée ou d'un autre projet iris, on transforme la valeur 
     * récupérée pour la transformer au format demandé par les composants eudofront
    */
    changeSavedDates() {
      if (this.value != null && this.value != '' && this.value.includes('T') && !this.$attrs['iris-mimic']) {
        this.savedDate = this.value.split('T')[0]
        this.savedTime = this.value.split('T')[1]
      } else if (this.value != null && this.value != '' && !this.value.includes('T') && this.$attrs['iris-mimic']) {
        this.convertFormat();
      } else if (this.value != null && this.value != '' && !this.value.includes('T') && !this.$attrs['iris-mimic']) {
        this.convertFormat();
        this.$emit('input', this.savedDate + 'T' + this.savedTime);
      } else {
        this.savedDate = null
        this.savedTime = null
      }
    },
    openMenu() {
      this.menu = true
    },
    onDateChange(e) {
      let dateString;
      if (this.formattedSavedDate && this.formattedSavedDate != "") {
        const parsed = fnsParse(this.formattedSavedDate, this.format, new Date(), {locale:this.getDateFnsLocale()});
        if (fnsIsValid(parsed)) {
          this.savedDate = fnsFormat(parsed, 'yyyy-MM-dd');
          this.formattedSavedDate = fnsFormat(fnsParseISO(this.savedDate), this.format, { locale: this.getDateFnsLocale() });
          dateString = this.savedDate + 'T' + this.savedTime
          while (this.savedDate.startsWith('0')) {//on retire les O 
            this.savedDate = this.savedDate.slice(1);
          }
        }

        this.$emit('onDateBlur',dateString)
      }
      this.customFocus(false);
    },
    customFocus(bool, tab) {
      //bool : est-ce que le focus est actif
      //tab : quel onglet est concerné

      this.$refs.dateIn.hasColor = bool
      this.$refs.dateIn.isFocused = bool

      if (tab != null || undefined) {
        this.currentTab = tab
      }
    },
    closeMenu(e) {
      if (!this.closeLocked) {
        this.menu = false
      }

    },
    closeMenuCombo(e) {
      //faut revoir le cas où on clique sur un boutton valider, ces champs ne sont pas rempli
      //l'event button-click passe avant l'event click outside
      if ((!this.savedDate || this.savedDate == "") && this.formattedSavedDate && this.formattedSavedDate != "") {
        const parsed = fnsParse(this.formattedSavedDate, this.format, new Date(), {locale:this.getDateFnsLocale()});
        if (fnsIsValid(parsed)) {
          this.savedDate = fnsFormat(parsed, 'yyyy-MM-dd');
          this.formattedSavedDate = fnsFormat(fnsParseISO(this.savedDate), this.format, { locale: this.getDateFnsLocale() });
          while (this.savedDate.startsWith('0')) {//on retire les O 
            this.savedDate = this.savedDate.slice(1);
          }
        }
      }
      
      if(this.savedDate && this.savedDate.endsWith('T'))
          this.savedDate = this.savedDate + this.formattedSavedTime;
      if (!this.closeLocked) {
        this.menu = false
      }
    },
    /**
     * cette methode permet de vérifier si la syntaxe de l'horaire est correcte
     */
    isTimeSyntaxIncorrect(time){
      return !time || time == '' || !time.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/g);
    },
    inputCheck(e) {
      let time = !e.text ? e : e.text
         if(this.isTimeSyntaxIncorrect(time)){
          //remettre l'ancienne valeur si la valeur selectionné ne match pas
          if(this.$refs.timePicker)
            this.$refs.timePicker.lazyValue =  this.$refs.timePicker.lazySearch = this.savedTime;
          this.formattedSavedTime = this.savedTime
          return;
         }
         else{
          this.savedTime = time
          this.formattedSavedTime = this.savedTime

        if (this.savedDate && this.savedTime) {
          let newDate = new Date(this.savedDate + ' ' + this.savedTime);
 
          if (fnsIsValid(newDate)) {
            let dateString = this.savedDate + 'T' + this.savedTime;

           
            this.$emit('onDateChange', dateString)
          }
        }
         }
      // Si on vient de la saisie guidée ou d'un autre projet iris, on renvoit la date au format demandé
      if (this.$attrs['iris-mimic']) {
        let dateTimeValue = "";
        if (this.savedDate != null)
          dateTimeValue += this.savedDate;

        if (this.savedTime != null)
          dateTimeValue += 'T' + this.savedTime;
        let val = fnsFormat(fnsParseISO(dateTimeValue), "dd/MM/yyyy HH:mm:ss", { locale: this.getDateFnsLocale() });
        
        return true;
      }

    
    },
    inputDate(e) {
      this.savedDate = e
      let newDate = new Date(this.savedDate);
      if (e && !this.savedTime)
        this.savedTime = '00:00'
      if (this.timeRequired) {
        this.currentTab = 1
      } else {
        this.menu = false
      }

      if (fnsIsValid(newDate)) {
        this.formattedSavedDate = fnsFormat(fnsParseISO(this.savedDate), this.format, { locale: this.getDateFnsLocale() });
              
        this.$emit('onDateChange', (this.savedDate + 'T' + (!this.savedTime?"00:00":this.savedTime)))
      }

    },
    userSave() {
      this.$refs.dTPkr.save(this.formattedSavedDate)
      setTimeout(() => {
        this.currentTab = null
        if (this.$refs.timePicker) {
          this.$refs.timePicker.resetSelect()
        }
      }, 500)
    },

    userCancel() {
      this.menu = false
      this.currentTab = 0
    },
    /** Convertit au bon format */
    convertFormat() {
      let dateSplitted = this.value.split(' ');
      let time = dateSplitted[0];
      let hour = dateSplitted[1].slice(0, 5) || '00:00';
      let timeSplitted = time.split('/');
      this.savedDate = timeSplitted[2] + '-' + timeSplitted[1] + '-' + timeSplitted[0];
      this.savedTime = hour;
    },
    fnsFormat,
    fnsParseISO,
    fnsParse

  },
}
</script>
<style lang="scss">
.calendar-container .v-select-list .v-list-item--disabled .v-list-item__content {
  color: rgba(0, 0, 0, .38);
}
</style>